import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import React from "react";
import { useTableColumnsContext, TableColumn } from "@components/Table/TableColumns";
import TableCell from "@components/Table/TableCell";

const TableRow: FCX<{
    index: number | null;
    isLoading?: boolean;
    onHover?: (index: number | null) => void;
    isSticky?: boolean;
}> = ({
    index,
    isLoading,
    isSticky,
    style,
    className,
    onHover,
    children,
    testId,
}) => {
    const { data } = useTableColumnsContext();

    const renderColumn = (col: TableColumn, colIndex: number, level: number = 0): React.ReactNode => {
        const hasSub = Array.isArray(col.subColumns) && col.subColumns.length > 0;

        return (
            <TableCell
                key={`${col.key}-${colIndex}`}
                isSub={level > 0}
                isLoading={isLoading}
                hasSub={hasSub}
                style={col.style?.cell}
                testId={`tableCell${index}_${colIndex}_${level}`}
                accentLevel={(isSticky && col.stickyConfig?.accentLevel) || col.accentLevel}
                sortingKey={col.sortKey}
                isSortHighlightHidden={col.isSortHighlightHidden ?? (colIndex === 0 && level === 0)}
                {...col.getHtmlAttributes?.(index ?? undefined)}
            >
                {index !== null && (
                    <>
                        {hasSub ? (
                            <div className="TableCellColumns">
                                {(col.subColumns ?? []).map((subCol, subIndex) =>
                                    renderColumn(subCol, subIndex, level + 1)
                                )}
                            </div>
                        ) : (
                            <>
                                {isSticky && col.stickyConfig?.Value ? (
                                    <col.stickyConfig.Value index={index} />
                                ) : (
                                    <col.Value index={index} />
                                )}
                            </>
                        )}
                    </>
                )}
            </TableCell>
        );
    };

    return (
        <div
            className={cn("TableRow", className)}
            style={style}
            data-testid={testId}
            onMouseEnter={() => onHover?.(index)}
            onMouseLeave={() => onHover?.(null)}
        >
            {data.map((col, colIndex) => renderColumn(col, colIndex, 0))}
            {children}
        </div>
    );
};

export default TableRow;
